import { ArrowDropDown, ArrowDropUp, Delete, Edit, MoreHorizOutlined } from "@mui/icons-material";
import { Menu, MenuItem, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import RemoveChannelModal from "../modals/RemoveChannelModal";
import EditChannelModal from "../modals/EditChannelModal";
import { useState } from "react";
import { formatTimestamp } from "../utils/formattimestamp";
import { formatPhoneNumber } from "../utils/formatnumber";
import { jwtDecode } from "jwt-decode";
import decryptApi from "../utils/decryptApi";

const ChannelList = ({channels, setChannels, channelUpdatedModal, setOpenChannelUpdatedModal}) => {
    const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });
  
    const handleSort = (key) => {
      setSortConfig((prevConfig) => ({
        key,
        direction:
          prevConfig.key ===  key && prevConfig.direction ===  "asc"
            ? "desc"
            : "asc",
      }));
    };
  
    const sortedRows = [...channels].sort((a, b) => {
      if (sortConfig.key) {
        const isAscending = sortConfig.direction ===  "asc";
        const aValue = a.M[sortConfig.key]?.S?.toLowerCase?.() || ""; // Handles case-insensitive comparison
        const bValue = b.M[sortConfig.key]?.S?.toLowerCase?.() || "";
  
        if (aValue < bValue) return isAscending ? -1 : 1;
        if (aValue > bValue) return isAscending ? 1 : -1;
      }
      return 0;
    });
  
    const renderSortIcon = (key) => {
      if (sortConfig.key ===  key) {
        return sortConfig.direction ===  "asc" ? (
          <ArrowDropUp fontSize="small" />
        ) : (
          <ArrowDropDown fontSize="small" />
        );
      }
      return <ArrowDropDown fontSize="small" className="opacity-50" />; // default icon
    };
  
    // Remaining code is unchanged
  
    const [anchorEl, setAnchorEl] = useState({});
    const [currentIndex, setCurrentIndex] = useState(0);
    const handleClick = (event, index) => {
      setAnchorEl((prev) => ({ ...prev, [index]: event.currentTarget }));
      setCurrentIndex(index); // Track the index of the clicked row
      console.log(anchorEl[index]);
    };
    
    const handleClose = (index) => {
      setAnchorEl((prev) => ({ ...prev, [index]: null }));
      setCurrentIndex(0); // Reset current index
    };
    const [openEditChannelModal, setOpenEditChannelModal] = useState(false);
    const [openDeleteChannelModal, setOpenDeleteChannelModal] = useState(false);
  
    // const [visibleIndexes, setVisibleIndexes] = useState({});
  
    // const toggleVisibility = (index) => {
    //   setVisibleIndexes((prev) => ({
    //     ...prev,
    //     [index]: !prev[index], // Toggle the visibility for the specific index
    //   }));
    // };

      async function decodeToken(token) {
          console.log(token)
              try {

                const dc = await decryptApi(token);

                console.log(dc)
               
                return dc
              } catch (error) {
                console.error('Invalid token:', error);
                return null;
              }
            }
  
    return (
      <div className="w-full overflow-x-auto lg:overflow-auto ">
        <div className="no-borders w-full" style={{ minWidth: "900px" }}>
          <div >
            <div className="grid grid-cols-13 text-[14px] text-[#030229] font-[400]  px-4 py-3">
              <div className=" cursor-pointer col-span-1"></div>
              <div
                className="   cursor-pointer col-span-2"
                // onClick={() => handleSort("type")}
              >
                Type {renderSortIcon("type")}
              </div>
              <div
                className="   cursor-pointer col-span-2"
                // onClick={() => handleSort("label")}
              >
                Name {renderSortIcon("label")}
              </div>
              <div
                className="  cursor-pointer col-span-3"
                // onClick={() => handleSort("details")}
              >
                Details {renderSortIcon("details")}
              </div>
              <div
                className="   cursor-pointer col-span-2"
                // onClick={() => handleSort("last_updated")}
              >
                Last Updated {renderSortIcon("last_updated")}
              </div>
              <div
                className="  cursor-pointer col-span-2 "
                style={{ textAlign: 'center', border: 'none' }}
                // onClick={() => handleSort("status")}
              >
                Status {renderSortIcon("status")}
              </div>
              <div
                className="  cursor-pointer col-span-1"
              ></div>
            </div>
          </div>
          <div>
            {channels && sortedRows.length > 0   ? sortedRows.map((row, index) => 
            {

             


              return(
                <div 
                  key={index}
                  className={"bg-white grid grid-cols-13 mb-6 rounded-[15px]  py-3 px-4 text-[14px] items-center "}
                  sx={{ border: "none" }}
                >
                  <div className="col-span-1">
                    <img src={"/icons/" + row.M.type.S + '.png'} className="w-[25px] object-cover" />
                  </div>
                  <div className="col-span-2">
                    {row.M.type.S ===  'forward_number' && 'Forward Number'}
                    {row.M.type.S ===  'email' && 'Email'}
                    {row.M.type.S ===  'slack' && 'Slack'}
                    {row.M.type.S ===  'front' && 'Front'}
                    {row.M.type.S ===  'sms' && 'SMS'}
                  </div>
                  <div className='col-span-2'>{row.M.label.S}</div>
                  <div className='col-span-3' id={'123-'+index} >
                   
                      
                        {row.M.type.S ===  'forward_number' || row.M.type.S === 'sms' ? formatPhoneNumber(row.M.value.S) : (
                          <>
                          {row.M.type.S ===  'slack'  ?  (row.M.value.S) : row.M.value.S}
                          </>
                        )}
                  </div>
                  <div className='col-span-2'>
                    <div className="flex items-center">
                      <img src={"/icons/calendar.png"} className="w-[10px] mr-2" />
                      {formatTimestamp(row.M.last_updated.S)}
                    </div>
                  </div>
                  <div className='col-span-2'>
                    {row.M.status.S ===  "pending" && (
                      <div className="text-[#F29339] bg-[rgba(242,147,57,0.1)] text-center py-2 rounded-[20px]">
                        Pending
                      </div>
                    )}
                    {row.M.status.S ===  "active" && (
                      <div className="text-[#3A974C] bg-[rgba(58,151,76,0.1)] text-center py-2 rounded-[20px]">
                        Active
                      </div>
                    )}
                    {row.M.status.S ===  "error" && (
                      <div className="text-[#E71D36] bg-[rgba(231,29,54,0.1)] text-center py-2 rounded-[20px]">
                        Error
                      </div>
                    )}
                  </div>
                  <div className='col-span-1 flex justify-end'>
                    <MoreHorizOutlined
                      sx={{ color: '#B3B3BF', cursor: 'pointer' }}
                      onClick={(event) => handleClick(event, index)}
                    />
                  </div>
                  <Menu
                    anchorEl={anchorEl[index]}
                    open={Boolean(anchorEl[index])}
                    onClose={() => handleClose(index)}
                    PaperProps={{
                      elevation: 1,
                      sx: {
                        bgcolor: "white",
                        overflow: "visible",
                        mt: 1.5,
                        boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
                        "&:before": {
                          content: '""',
                          display: "block",
                          position: "absolute",
                          top: 0,
                          left: "14px",
                          width: 10,
                          height: 10,
                          bgcolor: "white",
                          zIndex: 0,
                        },
                        borderRadius: "10px",
                        padding: 1,
                      },
                    }}
                    transformOrigin={{ horizontal: "center", vertical: "top" }}
                    anchorOrigin={{ horizontal: "center", vertical: "bottom" }}
                  >
                    <EditChannelModal open={openEditChannelModal} setOpen={setOpenEditChannelModal} 
                    channel_data={sortedRows[currentIndex].M} setChannels={setChannels}
                     closeMenu={handleClose} index={index} channelUpdatedModal={channelUpdatedModal}
                      setOpenChannelUpdatedModal={setOpenChannelUpdatedModal} />
    
                    <RemoveChannelModal open={openDeleteChannelModal} setOpen={setOpenDeleteChannelModal}
                     channel_data={sortedRows[currentIndex].M} setChannels={setChannels}
                      closeMenu={handleClose} index={index} />
                    <MenuItem
                      sx={{
                        bgcolor: "rgba(91,147,255,0.1)",
                        borderRadius: "8px",
                        mb: 0.5,
                        padding: "10px 16px",
                        fontSize: "14px",
                      }}
                      onClick={() => setOpenEditChannelModal(true)}
                    >
                      <div className="space-x-3 flex items-center">
                        <Edit fontSize="" sx={{ color: '#5B93FF' }} />
                        <div className="font-[14px] text-[#5B93FF]">Edit</div>
                      </div>
                    </MenuItem>
                    <MenuItem
                      sx={{
                        bgcolor: "rgba(231,29,54,0.1)",
                        borderRadius: "8px",
                        padding: "10px 16px",
                        fontSize: "14px",
                      }}
                      onClick={() => setOpenDeleteChannelModal(true)}
                    >
                      <div className="space-x-3 flex items-center">
                        <Delete fontSize="" sx={{ color: "#E71D36" }} />
                        <div className="font-[14px] text-[#E71D36]">Delete</div>
                      </div>
                    </MenuItem>
                  </Menu>
                </div>
  
              )

            }
          
          ): (
              <div className="text-[12px] lg:text-[13px] text-center pt-3"> 
              You do not have any channels created yet. Click the "Add Channel" button to create one. Need help?  
              <a className="text-blue-800 hover:underline" href='mailto:hello@twilanswer.com'> Contact Support</a>
              .
              </div>
            )
            
            }
          </div>
        </div>
      </div>
    );
  };
export default ChannelList  